import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import { Grid, Skeleton, Typography } from "@mui/material";
import React from "react";

const UserRoleHeaderSkeleton = () => {
  return (
    <Grid
      item
      xs={12}
      sx={{
        background: "#F9FAFC",
        width: "100%",
        border: "1px solid #EDEFEF",
        borderRadius: "5px",
      }}
    >
      <Grid
        container
        padding={"1rem"}
        height={"9vh"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item sx={{ display: "flex", alignItems: "center" }}>
          <ManageAccountsOutlinedIcon
            sx={{
              background: "#9AAFC4",
              fontSize: "60px !important",
              marginLeft: "10px",
              aspectRatio: 1,
              borderRadius: "50%",
              padding: "5px",
              color: "#F9FAFC",
            }}
          />
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            <span style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
              <Skeleton variant="rectangular" width={150} height={20} />
            </span>
          </Typography>
        </Grid>
        <Grid item>
          <Grid container>
            <Grid item>
              <Typography sx={{ cursor: "pointer", color: "#1D4A87" }}>
                <DeleteOutlineIcon sx={{ marginLeft: "5px" }} />
                حذف نقش
              </Typography>
            </Grid>
            <span
              style={{
                marginLeft: "2vh",
                marginRight: "2vh",
                background: "#CFD8DC",
                height: "3vh",
                width: "2px",
              }}
            ></span>
            <Grid item>
              <Typography sx={{ cursor: "pointer", color: "#1D4A87" }}>
                <EditIcon sx={{ marginLeft: "5px" }} />
                ویرایش نقش
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserRoleHeaderSkeleton;
